var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6E6E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0257 14H26.1726L21.4826 19.0833L27 26H22.6796L19.2965 21.8047L15.4248 26H13.2758L18.2927 20.5633L13 14H17.4296L20.4886 17.8347L24.0257 14ZM23.2725 24.7813H24.4625L16.7828 15.1547H15.506L23.2725 24.7813Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.fd16dd754198cb5b53f3d5cf0c580679.svg";
export { ForwardRef as ReactComponent };